import { observer } from "mobx-react-lite";
import { InputNumber } from "antd";
import { useTranslation } from "react-i18next";
import { StageTaskType } from "@/store/Lifecycle/constants";
import { getTaskFieldMetadata } from "./constants";
import { AutoSaverFormItem } from "./AutoSaverFormItem";
import { useTask } from "./Provider";
import { computeValidateStatus } from "./utils";

export const PercentageField = observer(() => {
    const task = useTask<StageTaskType.Percentage>();
    const { name, value, validateStatus, help, isReadOnly, isSaving, required } = getTaskFieldMetadata(task);
    const { t } = useTranslation();

    const computedValidateStatus = computeValidateStatus(value, validateStatus);

    return (
        <AutoSaverFormItem 
            name={name} 
            initialValue={value} 
            className='stage-task-input-field' 
            hasFeedback 
            validateStatus={computedValidateStatus} 
            help={t(help)}
            required={required}
        >
            <InputNumber 
                className='stage-task-input'
                size='large'
                value={value}
                disabled={isReadOnly || isSaving}
                min={0}
                max={1}
                step={0.01}
                formatter={value => value ? `${(value * 100).toFixed()}%` : ''}
                parser={value => value ? +value?.replace('%', '') / 100 : null}
            />
        </AutoSaverFormItem>
    );
}); 